export default __webpack_public_path__ + "static/media/뜨개질_웹.516ae636.jpg";